import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PlusCircle,
  Edit,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { getAllSuppliers, deleteSupplier } from "../../core/api/settings";
import Table from "../../core/pagination/datatable";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import SupplierDetailsView from "./supplierdetailsview";
import { useSelector } from "react-redux";
import { message } from "antd";

const Suppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [isSupplierDetailsVisible, setSupplierDetailsVisible] = useState(false);
  const [currentSupplierId, setCurrentSupplierId] = useState(null);
  const MySwal = withReactContent(Swal);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [loading, setLoading] = useState(false);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [clientId, setClientId] = useState(null);
  const loadSuppliers = async () => {
    setLoading(true);
    try {
      const response = await getAllSuppliers(selectedClients);
      setSuppliers(
        response.data.map((supplier) => ({
          ...supplier,
          type: supplier.type?.name || "N/A",
        }))
      );
    } catch (err) {
      console.error("Failed to fetch suppliers", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadSuppliers();
  }, [selectedClients]);

  const showConfirmationAlert = (supplierId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteSupplier(supplierId);
          setSuppliers((prevSuppliers) =>
            prevSuppliers.filter((supplier) => supplier.id !== supplierId)
          );
          MySwal.fire({
            title: "Deleted!",
            text: "The supplier has been deleted.",
            icon: "success",
          });
        } catch (err) {
          console.error("Failed to delete supplier", err);
          MySwal.fire({
            title: "Error!",
            text: "Failed to delete supplier.",
            icon: "error",
          });
        }
      } else {
        MySwal.close();
      }
    });
  };

  const handleAddSupplier = () => {
    if (!selectedClients) {
      message.warning("Please select a client.");
      return;
    }
    if (selectedClients.length === 0) {
      message.warning("Please select a client.");
      return;
    }

    if (selectedClients.length > 1) {
      message.warning("Please select one client.");
      return;
    }

    if (selectedClients[0] === "all") {
      message.warning("Please select one client.");
      return;
    }
    setClientId(selectedClients[0]);
    setCurrentSupplierId(null);
    setSupplierDetailsVisible(true);
  };

  const handleEditSupplier = (supplierId, clientId) => {
    setCurrentSupplierId(supplierId);
    setClientId(clientId);
    setSupplierDetailsVisible(true);
  };

  const handleCloseSupplierDetails = () => {
    setSupplierDetailsVisible(false);
    loadSuppliers();
  };

  const columns = [
    {
      title: "Brand",
      dataIndex: "brand_name",
      width: 150,
    },
    {
      title: "Supplier Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img" hidden>
            <ImageWithBasePath alt="" customSrc={record.logo} />
          </Link>
          <Link to="#">{text}</Link>
        </span>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Website",
      dataIndex: "website",
      width: 100,
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      width: 100,
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 150,
    },
    {
      title: "Contact Name",
      dataIndex: "contact_name",
      width: 160,
    },
    {
      title: "Action",
      dataIndex: "action",
      fixed: "right",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to="#"
              className="me-2 p-2"
              title="Edit"
              onClick={() => handleEditSupplier(record.id, record.client_id)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              to="#"
              onClick={() => showConfirmationAlert(record.id)}
              className="p-2"
              title="Delete"
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        className="content"
        style={{
          width: isSupplierDetailsVisible
            ? `calc(100% - ${sidebarWidth}px)`
            : "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Suppliers List</h4>
              <h6>Manage your suppliers</h6>
            </div>
          </div>
          <div className="page-btn">
            <button className="btn btn-added" onClick={handleAddSupplier}>
              <PlusCircle className="me-2 iconsize" />
              Add New Supplier
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={suppliers}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>

      <SupplierDetailsView
        isVisible={isSupplierDetailsVisible}
        onClose={handleCloseSupplierDetails}
        supplierId={currentSupplierId}
        onResize={setSidebarWidth}
        clientId={clientId}
      />
    </div>
  );
};

export default Suppliers;
